import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AppLocale, getCurrentLanguage } from "../../languageProvider";
import { getCurrentUser, acceptMyInvitation } from "../../api/server";

const initialState = {
  language: "hebrew",
  currentAppLocale: AppLocale["he"],
  profile: null,
  theme: "light",
  loading: true,
  error: null,
  scopePrefix: null,
  signingOutProcess: false,
  changedItems: {
    changed: [],
    values: [],
  },
  twoFAResolved: null,
  is2FA: null,
  registrationInProgress: false,
  invitationAccepted: false,
  activeBranch: null,
  hasPermissions: true,
};

export const fetchUserProfile = createAsyncThunk(
  "user/fetchUserProfile",
  getCurrentUser
);

export const acceptInvitation = createAsyncThunk(
  "registration/acceptInvitation",
  acceptMyInvitation
);

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    setLanguage(state, action) {
      const { language } = action.payload;
      const currentAppLocale = AppLocale[getCurrentLanguage(language).locale];
      state.language = language;
      state.currentAppLocale = currentAppLocale;
    },
    setTheme(state, action) {
      state.theme = action.payload;
    },
    setActiveBranch(state, action) {
      state.activeBranch = action.payload;
    },
    setUser(state, action) {
      state.profile = action.payload && action.payload;
      state.loading = false;
    },
    setScope(state, action) {
      state.scopePrefix = action.payload;
    },
    setSigningOutProcess(state, action) {
      state.signingOutProcess = action.payload;
    },
    setChangedFormItems(state, action) {
      const { changed, values } = action.payload;
      state.changedItems.changed = changed;
      state.changedItems.values = values;
    },
    setTwoFAResolved(state, action) {
      state.twoFAResolved = action.payload;
    },
    setIs2FA(state, action) {
      state.is2FA = action.payload;
    },
    setRegistrationInProgress(state, { payload }) {
      state.registrationInProgress = payload;
    },
    setHasPermissions(state, { payload }) {
      state.hasPermissions = payload;
    },
  },
  extraReducers: {
    [fetchUserProfile.fulfilled]: (state, action) => {
      state.profile = action.payload.data;
      state.loading = false;
    },
    [fetchUserProfile.rejected]: (state) => {
      state.profile = null;
      state.loading = false;
    },
  },
});

export const {
  setLanguage,
  setUser,
  setTheme,
  setActiveBranch,
  setScope,
  setSigningOutProcess,
  setChangedFormItems,
  setTwoFAResolved,
  setIs2FA,
  setRegistrationInProgress,
  setHasPermissions,
} = authSlice.actions;

export default authSlice.reducer;
